import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default KeyboardArrowDownIcon;
